import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Layout } from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Companies from './pages/Companies';
import Drivers from './pages/Drivers';
import Vehicles from './pages/Vehicles';
import IntegrationConfig from './pages/IntegrationConfig';
import WhatsAppEmulator from './pages/WhatsAppEmulator';
import Shipments from './pages/Shipments';
import DriverPWA from './pages/DriverPWA';
import '@/App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          
          {/* Public PWA route - Driver access via token from WhatsApp */}
          <Route path="/pwa/t/:token" element={<DriverPWA />} />
          
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <Layout><Dashboard /></Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/companies" element={
            <ProtectedRoute allowedRoles={['super_admin']}>
              <Layout><Companies /></Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/drivers" element={
            <ProtectedRoute allowedRoles={['super_admin', 'empresa_admin', 'logistica']}>
              <Layout><Drivers /></Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/vehicles" element={
            <ProtectedRoute allowedRoles={['super_admin', 'empresa_admin', 'logistica']}>
              <Layout><Vehicles /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/shipments" element={
            <ProtectedRoute allowedRoles={['super_admin', 'empresa_admin', 'logistica']}>
              <Layout><Shipments /></Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/integration-config" element={
            <ProtectedRoute allowedRoles={['super_admin', 'empresa_admin']}>
              <Layout><IntegrationConfig /></Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/whatsapp-emulator" element={
            <ProtectedRoute allowedRoles={['super_admin', 'empresa_admin', 'logistica']}>
              <Layout><WhatsAppEmulator /></Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
